const textCleanup = (content: string): string =>
  (content || '')
    .toString()
    .replace(/\n/gi, '  \n')
    .replace(/\u2028/g, ' ')
    .replace(/&shy;/g, '\u00ad');

export default textCleanup;
